import React from 'react';

const MesaSelector = ({ show, mesas, selectedMesa, onSelect, onClose }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center pt-16 bg-black/30" onClick={onClose}>
      <div className="bg-white rounded-2xl shadow-2xl p-4 w-80" onClick={e => e.stopPropagation()}>
        <p className="font-semibold text-gray-700 mb-3">Seleccionar mesa</p>
        <div className="grid grid-cols-5 gap-2">
          <button onClick={() => { onSelect(null); onClose(); }}
            className={`h-14 rounded-xl font-bold text-sm transition-all ${!selectedMesa ? 'bg-gray-800 text-white' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}>
            Sin
          </button>
          {mesas.map(mesa => (
            <button key={mesa.numero} onClick={() => { onSelect(mesa.numero); onClose(); }}
              className={`h-14 rounded-xl font-bold text-lg transition-all ${selectedMesa === mesa.numero ? 'bg-green-500 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}
              data-testid={`mesa-btn-${mesa.numero}`}>
              {mesa.numero}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MesaSelector;
